import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import {
  getCountryCodeFromMetaTag,
  getPageLocale,
  telInputLocaleSearch,
} from '@msc-b2c/shared-utils';

export class InputTel {
  private readonly inputTel: HTMLInputElement;
  private readonly enableFlags: boolean;
  private readonly enablePrefixSearch: boolean;
  private telInstance: any;

  constructor(inputTel: HTMLInputElement) {
    this.inputTel = inputTel;
    this.enableFlags = Boolean(inputTel.dataset?.['enableFlags']);
    this.enablePrefixSearch = Boolean(inputTel.dataset?.['enablePrefixSearch']);
  }

  init() {
    if ((this.inputTel as any)._itiInitialized) return (this.inputTel as any)._itiInstance; // prevent double init
    (this.inputTel as any)._itiInitialized = true;

    this.telInstance = intlTelInput(this.inputTel, {
      initialCountry: getCountryCodeFromMetaTag(),
      validationNumberType: 'MOBILE',
      i18n: telInputLocaleSearch[getPageLocale()],
      separateDialCode: true,
      strictMode: true,
      countrySearch: this.enablePrefixSearch,
      showFlags: this.enableFlags || true,
      fixDropdownWidth: true,
      autoPlaceholder: 'off', //removing default placeholder for each country
      //For local only use a different utilsScript: ../../../../../libs/base-style/src/lib/resources/additional-static-libs/intl-tel-input-utils.js
      //For remote use a different utilsScript: resources/additional-static-libs/intl-tel-input-utils.js
      utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.5.0/build/js/utils.js',
    });

    (this.inputTel as any)._itiInstance = this.telInstance;
    return this.telInstance;
  }
}

// Initialize existing inputs on page load
const initializeTelInputs = () => {
  document.querySelectorAll('.cmp-form-text__text[type="tel"]').forEach((node) => {
    new InputTel(node as HTMLInputElement).init();
  });
};

requestAnimationFrame(() => {
  initializeTelInputs();

  // Watch for dynamically added inputs
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (
          node instanceof HTMLElement &&
          node.matches('.cmp-form-text__text[type="tel"]:not(.tel-input-not-editorial)')
        ) {
          new InputTel(node as HTMLInputElement).init();
        }

        // In case the input is nested inside the added node
        if (node instanceof HTMLElement) {
          node
            .querySelectorAll('.cmp-form-text__text[type="tel"]:not(.tel-input-not-editorial)')
            .forEach((input) => {
              new InputTel(input as HTMLInputElement).init();
            });
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
